import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { userSchema } from "../user";

const namePartSchema = z.string().trim().min(1).max(255);

export const registerSchema = userSchema
  .pick({ email: true, locale: true })
  .extend({
    firstName: namePartSchema,
    lastName: namePartSchema,
    password: z.string().min(6),
  });

export class RegisterDto extends createZodDto(registerSchema) {}
